// src/features/geospatial/pages/ZoneCreatePage.jsx

import { useEffect, useState } from "react";
import { Box, CssBaseline, Grid, Paper } from "@mui/material";

import ZoneForm from "../components/ZoneForm";
import GoogleMapView from "../components/GoogleMapView";
import ZoneStatistics from "../components/ZoneStatistics";
import ZoneToolbar from "../components/ZoneToobar";
import { Snackbar, Alert } from "@mui/material";
import { createZoneUseCase } from "../domain/usecases/createZoneUseCase";
import Topbar from "../../../components/topbar/TopBar";
import { getCountryListUseCase } from "../../geography_catalog/country/domain/usecases/getCountryListUseCase";
import { getDepartmentListByCountryIdUseCase } from "../../geography_catalog/department/domain/usecases/getDepartmentListByCountryIdUseCase";
import { getProvinceListByDepartmentIdUseCase } from "../../geography_catalog/province/domain/usecases/getProvinceListByDepartmentIdUseCase";

export default function ZoneCreatePage() {
  const [form, setForm] = useState({
    countryId: "",
    departmentId: "",
    provinceId: "",
    name: "",
    description: "",
    isSpecial: false,
    multiplier: "1.00",
    resolution: 8,
  });
  const [countries, setCountries] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [provinces, setProvinces] = useState([]);

  const [loading, setLoading] = useState(false);

  const [message, setMessage] = useState({
    open: false,
    type: "success",
    text: "",
  });

  const [polygon, setPolygon] = useState([]);

  const [clearTrigger, setClearTrigger] = useState(0);

  const handleClearMap = () => {
    setClearTrigger((prev) => prev + 1);
  };

  const [mapMode, setMapMode] = useState("draw");

  useEffect(() => {
    const loadCountries = async () => {
      try {
        const records = await getCountryListUseCase();
        setCountries(records);
        if (records.length > 0) {
          setForm((prev) => ({
            ...prev,
            countryId: String(records[0].id),
          }));
        }
      } catch (error) {
        setMessage({
          open: true,
          type: "error",
          text: error.message || "No se pudo cargar la lista de paises.",
        });
      }
    };

    loadCountries();
  }, []);

  useEffect(() => {
    const loadDepartments = async () => {
      if (!form.countryId) {
        setDepartments([]);
        setProvinces([]);
        return;
      }

      try {
        const records = await getDepartmentListByCountryIdUseCase(form.countryId);
        setDepartments(records);
        setForm((prev) => ({
          ...prev,
          departmentId: records[0] ? String(records[0].id) : "",
          provinceId: "",
        }));
      } catch (error) {
        setDepartments([]);
        setProvinces([]);
        setMessage({
          open: true,
          type: "error",
          text: error.message || "No se pudo cargar la lista de departamentos.",
        });
      }
    };

    loadDepartments();
  }, [form.countryId]);

  useEffect(() => {
    const loadProvinces = async () => {
      if (!form.departmentId) {
        setProvinces([]);
        return;
      }

      try {
        const records = await getProvinceListByDepartmentIdUseCase(
          form.departmentId,
        );
        setProvinces(records);
        setForm((prev) => ({
          ...prev,
          provinceId: records[0] ? String(records[0].id) : "",
        }));
      } catch (error) {
        setProvinces([]);
        setMessage({
          open: true,
          type: "error",
          text: error.message || "No se pudo cargar la lista de provincias.",
        });
      }
    };

    loadProvinces();
  }, [form.departmentId]);

  const handleDrawMode = () => {
    setMapMode("draw");
  };

  const handleMoveMode = () => {
    setMapMode("move");
  };

  const handlePreviewH3 = () => {
    console.log("Preview H3 polygon:", polygon);
  };

  const handleSave = async () => {
    const payload = {
      countryId: Number(form.countryId),
      departmentId: Number(form.departmentId),
      provinceId: Number(form.provinceId),
      name: form.name,
      description: form.description,
      isSpecial: Boolean(form.isSpecial),
      multiplier: Number(form.multiplier),
      resolution: Number(form.resolution),
      polygon,
    };

    try {
      setLoading(true);

      await createZoneUseCase(payload);

      setMessage({
        open: true,
        type: "success",
        text: "Zona geoespacial creada correctamente.",
      });

      setForm({
        countryId: countries[0] ? String(countries[0].id) : "",
        departmentId: "",
        provinceId: "",
        name: "",
        description: "",
        isSpecial: false,
        multiplier: "1.00",
        resolution: 8,
      });

      setPolygon([]);
      setClearTrigger((prev) => prev + 1);
    } catch (error) {
      setMessage({
        open: true,
        type: "error",
        text: error.message || "No se pudo crear la zona.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <CssBaseline />
      <main className="content">
        <Topbar />
        <Box sx={{ minHeight: "100vh", p: 1 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4} lg={3}>
              <Paper
                elevation={2}
                sx={{
                  borderRadius: 3,
                  display: "flex",
                  flexDirection: "column",
                  overflow: "hidden",
                }}
              >
                <ZoneForm
                  form={form}
                  setForm={setForm}
                  countries={countries}
                  departments={departments}
                  provinces={provinces}
                  polygon={polygon}
                  loading={loading}
                  message={message}
                  onSave={handleSave}
                  onClearMap={handleClearMap}
                />
                {/* 
            <ZoneStatistics vertices={polygon.length} /> */}
              </Paper>
            </Grid>

            <Grid item xs={12} md={8} lg={9}>
              <Paper
                elevation={2}
                sx={{
                  position: "relative",
                  height: {
                    xs: 420,
                    sm: 500,
                    md: "calc(100vh - 48px)",
                  },
                  minHeight: 420,
                  borderRadius: 3,
                  overflow: "hidden",
                }}
              >
                <ZoneToolbar
                  mode={mapMode}
                  onDrawMode={handleDrawMode}
                  onMoveMode={handleMoveMode}
                  onClearMap={handleClearMap}
                  onPreviewH3={handlePreviewH3}
                />

                <GoogleMapView
                  onPolygonChange={setPolygon}
                  clearTrigger={clearTrigger}
                />
              </Paper>
            </Grid>
          </Grid>

          <Snackbar
            open={message.open}
            autoHideDuration={4000}
            onClose={() =>
              setMessage((prev) => ({
                ...prev,
                open: false,
              }))
            }
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <Alert
              severity={message.type}
              variant="filled"
              onClose={() =>
                setMessage((prev) => ({
                  ...prev,
                  open: false,
                }))
              }
            >
              {message.text}
            </Alert>
          </Snackbar>
        </Box>
      </main>
    </>
  );
}
